// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"0":"80b3f924e871bb834a17","405":"a5a04d231f8feb7e117b","837":"0ab861e0b44cd89c860a","885":"513deb0fcc50988cb753"}[chunkId] + ".css";
};